import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight } from 'lucide-react';
import Button from '../components/common/Button';

const InternetProblem: React.FC = () => {
  return (
    <div className="min-h-[calc(100vh-12rem)] flex flex-col items-center justify-center bg-gradient-to-b from-blue-50 to-white px-4 py-16">
      <div className="text-center max-w-2xl">
        <div className="inline-flex items-center justify-center p-3 bg-blue-100 rounded-full mb-6">
          <BookOpen className="h-10 w-10 text-blue-600" />
        </div>
        
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Problema com a sua conexão
        </h1>
        
        <p className="text-xl text-gray-600 mb-8 max-w-lg mx-auto">
          Tente recarregar a página ou tente novamente mais tarde!
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
          <Link to="/login">
            <Button size="lg" rightIcon={<ArrowRight className="h-5 w-5" />}>
              Recarregar
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default InternetProblem;